import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { CoordinatorList } from './CoordinatorList'
import { useRegistrationStore } from '@/lib/store/registrationStore'
import { Info } from 'lucide-react'

export function DuplicateRegistrationDialog() {
  const { showDuplicateDialog, duplicateData, setShowDuplicateDialog } = useRegistrationStore()

  if (!duplicateData) return null

  return (
    <Dialog open={showDuplicateDialog} onOpenChange={setShowDuplicateDialog}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <div className="flex items-center gap-2">
            <Info className="w-5 h-5 text-primary" />
            <DialogTitle>Already Registered</DialogTitle>
          </div>
          <DialogDescription className="pt-2">
            You have already submitted the form and registered for:
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          <p className="text-base font-semibold text-primary">
            {duplicateData.sport_names.join(', ')}
          </p>

          <p className="text-sm text-slate-600">
            Please contact YUVA volunteers in case you want to make any changes.
          </p>

          <CoordinatorList />
        </div>

        <DialogFooter>
          <Button onClick={() => setShowDuplicateDialog(false)}>Close</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
